import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import { HeroUIProvider } from '@heroui/react';
import { MainErrorFallback } from '@/components/errors/main';
import { queryConfig } from '@/lib/react-query';
import { Spinner } from '@heroui/react';
import { IS_DEV } from '@/helpers/constants';
import { createAppRouter } from '@/app/router';
import { RouterProvider } from 'react-router-dom';
import { Suspense, useState } from 'react';
import { PHProvider } from '@/app/posthog-provider';

export const AppProvider = () => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      })
  );

  const appRouter = createAppRouter(queryClient);

  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center">
          <Spinner size="lg" />
        </div>
      }
    >
      <HeroUIProvider navigate={appRouter.navigate}>
        <Sentry.ErrorBoundary fallback={MainErrorFallback}>
          <HelmetProvider>
            <QueryClientProvider client={queryClient}>
              <PHProvider>
                {IS_DEV && <ReactQueryDevtools />}
                <RouterProvider router={appRouter} />
              </PHProvider>
            </QueryClientProvider>
          </HelmetProvider>
        </Sentry.ErrorBoundary>
      </HeroUIProvider>
    </Suspense>
  );
};
